export enum FlowPressure {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}
